import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ChatsService from '../../controllers/ChatController';
import { closeConversationByAgent } from '../../redux/interactionsSlice';
class CloseConfirmation extends Component {
    constructor(props) {

        super(props)

        this.closeChat = this.closeChat.bind(this);
    }

    closeChat() {
        this.props.closeConversationByAgent(this.props.interaction.id);
        ChatsService.closeConversation(this.props.interaction.id);
        this.props.toggleModal();
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} size="md" backdrop="static">
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={duotone("warning")} /> {this.props.t("warning")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>{this.props.t("youarebouttoclosechat")}</p>
                            <p>{this.props.t("areyousure")}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.closeChat}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        chatUrl: state.parameters.chatUrl,
        LOADING_TYPE: state.parameters.LOADING_TYPE,
        agentName: state.agent.name,
        userId: state.agent.userId,
        showSearch: state.interaction.showSearch,
        interaction: state.interaction.current
    };
};
export default compose(connect(mapStateToProps, { closeConversationByAgent }), withTranslation())(CloseConfirmation);